import { reactive, toRefs } from "@vue/composition-api";
import { useMemberDetails } from "./member-details";
import { registrationConfig } from "./config";

let memData = null;

export function useMembershipTypes() {
  let member = (window.Distinction && window.Distinction.member) || {};
  if (memData === null)
    memData = reactive({
      typeCode: member.MembershipType || "",
      statusCode: member.MembershipStatus || "",
    });

  function setMembershipData(typeCode, statusCode) {
    memData.typeCode = typeCode;
    memData.statusCode = statusCode;

    const { membershipType, membershipStatusType } = useMemberDetails();

    membershipStatusType.value = statusCode;

    const fee = registrationConfig.fees.find(
      (f) => f.memTypeCode === typeCode && f.memStatusCode === statusCode,
    );
    membershipType.value = fee ? fee.title : null;
  }

  return {
    ...toRefs(memData),
    setMembershipData,
    fees: registrationConfig.fees,
  };
}

export const studentCodes = process.env.VUE_APP_STUDENT_CODES.split(",");
